var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 359.4 359.4",
    style: {
      enableBackground: "new 0 0 359.4 359.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#595757;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#2C6CFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.3,151.9c-2.1-2.7-5-6-8.6-9.7c-11.5-11.4-31.4-27.8-51.5-41c-20.8-13.6-42.1-23.5-55.6-23.5 c-18.1,0-29.5,7-39.7,14.2c-6.4,4.5-11.7,9.8-20.2,9.8c-8.3,0-13.7-5.2-20.1-9.8c-10.2-7.2-21.8-14.2-39.8-14.2 c-12.5,0-28.9,6.9-45.5,17.4C46,113.1,16.5,140.7,6.8,150c-4.9,2.8-6.8,6.9-6.8,11.7c0,2.2,0.9,6.5,4.1,11.8 c6.6,11.1,25.9,33.8,54.1,57.3c28.8,23.9,64.6,50.7,121.6,50.7c57,0,92.7-26.8,121.4-50.7c28.2-23.5,47.5-46.2,54.1-57.3 c3.2-5.3,4.1-9.6,4.1-11.8C359.4,157.9,358.2,154.6,355.3,151.9z M324.3,173.7c-9.1,10.7-22.8,25.8-38.5,38.8 c-25.2,21-56.1,45.2-106,45.2c-49.9,0-81-24.2-106.3-45.2c-11.4-9.4-21.7-20-30-29.1c0,0,0,0,0,0c-27.2-18.8-1.8-32.9-1.8-32.9 c12.6-11.1,29.2-24.7,45.4-34.9c12.1-7.6,23.6-13.7,32.7-13.7c14.8,0,22.9,7.7,31.1,13.4c8.6,6,17.3,10.6,28.8,10.6 c11.7,0,20.4-4.6,29-10.6c8.2-5.7,16.1-13.4,30.9-13.4c10.5,0,26.3,9,42.4,19.5c13.7,9,27.3,19.6,37.8,28.7 c-0.7,0.1-1.5,0.2-2.2,0.4l6.7,0C339.7,159.9,324.3,173.7,324.3,173.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324.3,173.7c-2.2,0.3-4.5,0.7-6.7,1c-33.7,5.8-88.4,17-137.8,17c-49.4,0-104.1-11.2-137.9-17 c-2.3-0.4-4.6-0.7-6.8-1.1c2.5,2.9,5.3,6.2,8.5,9.7c-27.2-18.8-1.8-32.9-1.8-32.9c32.8,5.5,88.2,17.3,138.1,17.3 c49.8,0,105.1-11.7,137.8-17.3l6.7,0C339.7,159.9,324.3,173.7,324.3,173.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/입호흡.19b4d421ec6c133343036659867026a4.svg";
export { ForwardRef as ReactComponent };